export default __webpack_public_path__ + "static/media/tocaya.24e12479.png";